module.exports = __webpack_public_path__ + "static/media/plus_circle.21e97245.svg";